<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ "missions.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="headerFilter">
      <form
        *ngIf="orders && !isLoadingFilterForm"
        [formGroup]="filterForm"
        (submit)="onFilter()"
        class="filterForm"
      >
        <mat-form-field class="siteGroup-filter">
          <mat-label>Groupe de donneurs d'ordre</mat-label>
          <mat-select
            formControlName="siteGroup"
            [compareWith]="compareSiteGroup"
            (selectionChange)="onFilter()"
          >
            <mat-option [value]="null">Tous</mat-option>
            <mat-option *ngFor="let group of siteGroups" [value]="group">
              {{ group.name }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="isSiteGroupIgnored">
            Ignoré : un donneur d'ordre est sélectionné
          </mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Entrer une période</mat-label>
          <mat-date-range-input formGroupName="range" [rangePicker]="picker">
            <input
              matStartDate
              formControlName="fromStartDate"
              placeholder="Du"
              (focus)="picker.open()"
            />
            <input
              matEndDate
              formControlName="toStartDate"
              placeholder="Au"
              (focus)="picker.open()"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <button
          mat-icon-button
          type="submit"
          color="primary"
          [disabled]="
            filterForm.pristine ||
            !filterForm.value.range.fromStartDate ||
            !filterForm.value.range.toStartDate
          "
          matTooltip="Filtrer"
        >
          <mat-icon> search </mat-icon>
        </button>

        <button
          mat-icon-button
          color="primary"
          matTooltip="Effacer les filtres"
          (click)="clearFilters()"
        >
          <mat-icon> clear </mat-icon>
        </button>
      </form>
      

      <section class="actionsButtons">
        <div class="toggleSubcontractor" *ngIf="canShowSubcontractorToggle">
          <mat-slide-toggle
            [(ngModel)]="useSubcontractorPrices"
            [ngModelOptions]="{standalone: true}"
            color="primary"
          >
            Utiliser les prix sous-traitants
          </mat-slide-toggle>
        </div>

        <div
          *ngIf="canExport"
          matTooltip="Vous devez sélectionner une tranche de date et un donneur d'ordre."
          [matTooltipDisabled]="
            filterForm.value.site &&
            filterForm.value.range.fromStartDate &&
            filterForm.value.range.toStartDate
          "
        >
          <button
            mat-raised-button
            color="primary"
            class="export-btn"
            (click)="onExportLetters()"
            [disabled]="
              isLoading ||
              !filterForm.value.site ||
              !filterForm.value.range.fromStartDate ||
              !filterForm.value.range.toStartDate
            "
            matTooltip="Exporter les lettres de voiture selon le donneur d'ordre et la date"
          >
            <mat-icon aria-label="File">insert_drive_file</mat-icon>
            {{ "orders.list.exportLetters" | translate }}
          </button>
        </div>

        <button
          *ngIf="canExport"
          mat-raised-button
          color="primary"
          class="export-btn"
          (click)="onExport()"
          [disabled]="isLoading || selection.selected.length === 0"
          matTooltip="Exporter la sélection"
        >
          <mat-icon aria-label="File">insert_drive_file</mat-icon>
          {{ "orders.list.export" | translate }}
        </button>

        <button
          *ngIf="canExport"
          mat-raised-button
          color="primary"
          class="export-btn"
          (click)="onExportAll()"
          [disabled]="isLoading"
          matTooltip="Exporter tout avec/sans filtre(s)"
        >
          <mat-icon aria-label="File">insert_drive_file</mat-icon>
          {{ "orders.list.exportAll" | translate }}
        </button>
      </section>
    </section>

    <div class="menuDisplayedColumns">
      <button
        mat-mini-fab
        color="primary"
        matTooltip="Préférences des colonnes"
        [matMenuTriggerFor]="menu"
      >
        <mat-icon>list</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <div cdkDropList (cdkDropListDropped)="drop($event)">
          <div
            *ngFor="let displayedColumn of displayedColumnsMenuMissions"
            cdkDrag
          >
            <section class="menu-item" (click)="$event.stopPropagation()">
              <ng-container *ngIf="displayedColumn.editable">
                <mat-checkbox
                  class="example-margin"
                  [checked]="displayedColumn.selected"
                  (change)="onSelectMenu($event, displayedColumn.name)"
                >
                  {{ "orders.list." + displayedColumn.name | translate }}
                </mat-checkbox>
              </ng-container>
            </section>
          </div>
        </div>
      </mat-menu>

      <button
        class="refreshButton"
        mat-raised-button
        color="primary"
        (click)="getList()"
      >
        Rafraichir
      </button>

      <form [formGroup]="filterForm">
        <mat-checkbox
          formControlName="includeDeleted"
          (click)="onFilter()"
          color="primary"
          >Afficher les commandes supprimées</mat-checkbox
        >
      </form>
    </div>

    <section class="datatable-container top-scrollbar">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="onSortChanged($event)"
        [formGroup]="filterForm"
      >
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="checkboxCell"></th>
          <td mat-cell *matCellDef="let row" class="checkboxCell">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <input
                class="identifier-filter"
                (click)="$event.stopPropagation()"
                (keydown.enter)="
                  $event.stopPropagation(); filterEnter($event, 'identifier')
                "
                matInput
                type="number"
                formControlName="identifier"
                placeholder="Filtre"
              />
              <span class="label labelIdentifier">{{
                "orders.list.identifier" | translate
              }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">{{ order.identifier }}</td>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "orders.list.startDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            {{ order.startDate | amDateFormat: "DD/MM/YYYY HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <input
                class="identifier-filter"
                (click)="$event.stopPropagation()"
                (keydown.enter)="
                  $event.stopPropagation(); filterEnter($event, 'name')
                "
                matInput
                type="text"
                formControlName="name"
                placeholder="Filtre"
              />

              <span class="label labelIdentifier">
                {{ "orders.list.name" | translate }}
              </span>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <app-transmission-badge
              [isTransmission]="order.type === orderType.transmission"
            ></app-transmission-badge>
            {{ order.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="urgency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <div class="autocompleteFilter">
                <span class="label">{{
                  "orders.list.urgency" | translate
                }}</span>
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('urgency')"
                  [list]="urgencies"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.urgency"> {{ order.urgency.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="sender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <div class="autocompleteFilter">
                <span class="label">{{
                  "orders.list.sender" | translate
                }}</span>
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('sender')"
                  [list]="senders"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.sender.otherAddress">
              {{ order.sender.otherAddress }}
            </span>
            <span *ngIf="!order.sender.otherAddress && order.sender.address">
              {{ order.sender?.address.name }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receivers">
          <th mat-header-cell *matHeaderCellDef>
            <div class="cellTh">
              <div class="autocompleteFilter">
                <span class="label">{{
                  "orders.list.receiver" | translate
                }}</span>
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('receiver')"
                  [list]="receivers"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.receivers.length > 1">
              <span *ngIf="order.receivers[order.receivers.length - 1].address">
                {{
                  order.receivers[order.receivers.length - 1].address.name
                }}
                (Multiples)</span
              >
              <span
                *ngIf="!order.receivers[order.receivers.length - 1].address"
              >
                {{
                  order.receivers[order.receivers.length - 1].otherAddress
                }}
                (Multiples)</span
              >
            </span>
            <span *ngIf="order.receivers.length === 1">
              <span *ngIf="order.receivers[0].address">
                {{ order.receivers[0].address.name }}</span
              >
              <span *ngIf="!order.receivers[0].address">
                {{ order.receivers[0].otherAddress }}</span
              >
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <div class="autocompleteFilter site-filter">
                <span class="label">Donneur d'ordre</span>
                <app-autocomplete
                  *ngIf="!isLoadingFilterForm"
                  [control]="filterForm.get('site')"
                  [isFilter]="true"
                  [list]="sites"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation()"
                  (selectedOptionForFilter)="filterEnter($event, 'site')"
                >
                </app-autocomplete>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.site"> {{ order.site?.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <mat-select
                class="status-filter"
                formControlName="status"
                (click)="$event.stopPropagation()"
                (selectionChange)="filterEnter($event, 'status')"
                placeholder="Filtre"
              >
                <mat-option
                  *ngFor="let status of allStatus"
                  [value]="status.value"
                >
                  {{ status.name }}
                </mat-option>
              </mat-select>

              <span class="label">{{ "orders.list.status" | translate }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            {{ showStatusText(order.status) | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <mat-select
                class="status-filter"
                formControlName="type"
                (click)="$event.stopPropagation()"
                (selectionChange)="filterEnter($event, 'type')"
                placeholder="Filtre"
              >
                <mat-option *ngFor="let type of allType" [value]="type.value">
                  {{ type.name }}
                </mat-option>
              </mat-select>
              <span class="label">{{ "orders.list.type" | translate }}</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            {{ showTypeText(order.type) | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <div class="autocompleteFilter">
                <span class="label">{{
                  "orders.list.client" | translate
                }}</span>
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('client')"
                  [list]="clients"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.client"> {{ order.client.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <div class="autocompleteFilter createdBy-filter">
                <span class="label">Créé par</span>
                <app-autocomplete
                  *ngIf="!isLoadingFilterForm"
                  [control]="filterForm.get('createdBy')"
                  [isFilter]="true"
                  [canString]="false"
                  [list]="users"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation()"
                  (selectedOptionForFilter)="filterEnter($event, 'createdBy')"
                >
                </app-autocomplete>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.createdBy"
              >{{ order.createdBy?.username }}
            </span>
            <span *ngIf="!order.createdBy">Système </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Créé le</th>
          <td mat-cell *matCellDef="let order">
            {{ order.createdOn | amDateFormat: "DD/MM/YYYY HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="timeSpent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Temps passé</th>
          <td mat-cell *matCellDef="let order">
            {{ order.timeSpent | formatHours }}
          </td>
        </ng-container>

        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              <div class="autocompleteFilter">
                <span class="label">Chauffeur</span>
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm"
                  [valueWanted]="'username'"
                  [control]="filterForm.get('driver')"
                  [list]="usersDrivers"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">{{ order.driver?.username }}</td>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="tdActions">
            {{ "orders.list.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let order" class="tdActions">
            <button
              mat-icon-button
              class="action-button"
              color="primary"
              [disabled]="isLoading"
              [matTooltip]="'orders.list.detail' | translate"
              (click)="onSelectOrder(order.id)"
            >
              <mat-icon aria-label="Edit">zoom_in</mat-icon>
            </button>

            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Menu boutons"
              color="primary"
              *ngIf="!order.isDeleted"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngIf="isDispatcher && order.status === 1"
                (click)="changeStatus('receivedByDispatcher', order)"
              >
                <mat-icon color="primary">call_received</mat-icon>
                <span>{{
                  "orders.list.receivedByDispatcher" | translate
                }}</span>
              </button>
              <button
                mat-menu-item
                *ngIf="isDispatcher && order.status === 2"
                (click)="changeStatus('cancelled', order)"
              >
                <mat-icon color="primary">clear</mat-icon>
                <span>{{ "orders.list.cancelled" | translate }}</span>
              </button>
              <button
                mat-menu-item
                *ngIf="
                  isDispatcher &&
                  (order.status === 1 || order.status === 2) &&
                  !order.driver
                "
                (click)="onSelectOrder(order.id)"
              >
                <mat-icon color="primary">drive_eta</mat-icon>
                <span>{{ "orders.list.assignDriver" | translate }}</span>
              </button>
              <button
                mat-menu-item
                *ngIf="isDispatcher && order.status === 8"
                (click)="changeStatus('finished', order)"
              >
                <mat-icon color="primary">block</mat-icon>
                <span>{{ "orders.list.finished" | translate }}</span>
              </button>
              <button
                mat-menu-item
                *ngIf="isAdmin && order.status === 128"
                (click)="changeStatus('finished', order)"
              >
                <mat-icon color="primary">flag</mat-icon>
                <span>{{ "orders.list.finished" | translate }}</span>
              </button>
              <button
                mat-menu-item
                *ngIf="!order.isDeleted && isDispatcher"
                (click)="changeTimeSpent(order)"
              >
                <mat-icon color="primary">access_time</mat-icon>
                <span>{{ "orders.list.changeTimeSpent" | translate }}</span>
              </button>
              <button mat-menu-item *ngIf="isAdmin" (click)="delete(order)">
                <mat-icon color="primary">delete</mat-icon>
                <span>{{ "orders.list.delete" | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          mat-row
          *matRowDef="let mission; columns: displayedColumns"
          class="mission"
          [ngClass]="{
            disabled: mission.status === 32 || mission.isDeleted,
          }"
        ></tr>
      </table>
    </section>

    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="primary"
    ></mat-progress-bar>
    <mat-paginator
      *ngIf="pagination"
      [pageSize]="pagination.pageSize"
      [length]="pagination.totalRecords"
      [pageIndex]="pagination.pageNumber - 1"
      (page)="onPageChanged($event)"
      showFirstLastButtons
    ></mat-paginator>
  </mat-card-content>
</mat-card>
